const accessToken = () => localStorage.getItem("authToken")
export default accessToken
